import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];
const updateTrackedChangesOnServer = async (resourceId, changes = {}, apiToken = null) => {
    console.log("CALLING SERVER with updatetrackedchanges")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'updatetrackedchanges',
            'foi': resourceId,
            'changes': changes,
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { 'success': true } 
            if (resp.data?.success) {
                return;
            } else {
                console.log("FAILED RESPONSE from updatetrackedchanges call")
                return null;
            }
        }
        console.log("NO RESPONSE from updatetrackedchanges call");
    }).catch((error) => { console.log(error); });
};

export default updateTrackedChangesOnServer;